export default __webpack_public_path__ + "static/media/innerBanner-unblured.e47a4922.png";